import './comp_engine_room_watching_certificate.css'

const Comp_Engine_Room_Watching_Certificate=(props)=>{
    return(

        <div class="engineroom-watching-certificate">
        <div class="header-container">
            <div class="header-box">Section 9.8- Engine Room Watchkeeping Certificate </div>
            <div class="header-box">To be issued by the Chief Engineer<br/>
            on every ship that the cadet serves</div>
        </div>
        
        <div class="logo-container">
            <img src="/logo.png" alt="university_insti" class="main-logo"/>
            <img src="/dg_shipping_logo.png" alt="General Logo" class="logo"/>
            {/* <img src="/umulogo.png" alt="Maritime Logo" class="logo"/> */}
        </div>
        
        <div class="certificate-title">Engine Room Watchkeeping Certificate</div>
        
        <div class="cadet-info">
            Name of Cadet: _______________________________<br/>
            Date of birth: _______________________________<br/>
            Passport number: _______________________________
        </div>
        
        <div class="headingg">This is to certify that the above named Cadet has served on board the ship</div>
        
        <div class="ship-period-line">
            <span></span> from <span></span> to <span></span>.
        </div>
        
        <div class="description">
        During this period of structured shipboard training, the Cadet has been observing and assisting the engineer officers in Engine Room
Watchkeeping duties in accordance with STCW 2010 Table A-1111 
        </div>
        
        <div  class="headingg">The number of Engine Room watches kept is as follows: </div>
        
        <div class="table-container">
            <table class="table">
                <tr>
                    <th>Engine Room watches </th>
                    <th>Total number of watches </th>
                    <th>Total Hours </th>
                </tr>
                <tr>
                    <td>At Sea </td>
                    <td></td>
                    <td></td>
                    
                </tr>
                <tr>
                <td>At Anchor </td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
            <div>
                <div class="signature-container">Master’s signature & ship’s stamp</div>
                <div class="signature-details">
                    <p>Master's Name: __________________________</p>
                    <p>Date: _____________</p>
                </div>
            </div>
        </div>
    
      </div>
    );
}

export default Comp_Engine_Room_Watching_Certificate
